import { Hub } from "aws-amplify";
import { gql, useQuery, useReactiveVar } from "@apollo/client";
import { Stack, Button, Typography } from "@mui/material";
import FileZone from "../../../component/FileZone";
import Notes from "../../../component/Notes";
import Updates from "../../../component/Updates";
import Item from "./components/Item";
import ShippingItems from "./components/shippingItems/ShippingItems";
import Packing from "./components/packing/Packing";
import DataGridComp from "../../../component/DataGrid";
import getFilteredItemsByUserRole from "../../../function/getFilteredItemsByUserRole";
import CreateShippingStepForm from "./components/CreateShippingStepForm";
import { getReceivingAndShipping, ShippingByTypeAndMaterial } from "./query";
import onDeleteShipping from "./onDelete";
import { downloadShippingList } from "./saveShippingList";
import { userEntityRelationVar } from "../../../client/cache";

function ItemView({ lineData: { id }, onClose }) {
  const { entityID } = useReactiveVar(userEntityRelationVar);

  let { data } = useQuery(gql(getReceivingAndShipping), {
    variables: { id },
    skip: !id,
  });

  // console.log({ data: 9999999 });
  data = data?.getReceivingAndShipping;

  if (!data) return null;

  const storagePath = `${entityID}/shippings/${data?.number}`;

  return (
    <Stack
      justifyContent="space-between"
      sx={{ width: 1500, height: 900, padding: 2 }}
    >
      <Stack spacing={5}>
        <Item data={{ ...data, definerID: entityID }} onClose={onClose} />
        <ShippingItems number={data.number} />
        <Packing number={data.number} definerID={entityID} />

        <FileZone storagePath={storagePath} />
        <Notes itemID={id} />
        <Updates itemID={id} />
      </Stack>

      <Button
        variant="contained"
        sx={{ alignSelf: "center", justifySelf: "flex-end" }}
        onClick={onClose}
      >
        back
      </Button>
    </Stack>
  );
}

function Comp({ entityType, userRole, isAuthenticated, entityID }) {
  const isAdmin = userRole?.includes("admin");

  const queryVariables = {
    type: "OUTGOING",
    // limit: 5000,
    // filter: {
    //   or: IDs.map((id) => ({
    //     vendorID: { eq: id },
    //   })),
    // },
  };

  const columns = [
    {
      field: "date",
      headerName: "Date",
      width: 180,
      userRole: ["admin", "sales", "warehouse"],
      // renderCell: ({ value,row, ...props }) => {
      //   console.log({ props });
      //   return (
      //     <Stack direction="row" spacing={2}>
      //       <Typography></Typography>
      //     </Stack>
      //   );
      // },
    },

    {
      field: "no",
      headerName: "Number",
      width: 240,
      userRole: ["admin", "sales", "warehouse"],
    },
    // {
    //   field: "itemNumber",
    //   headerName: "Item",
    //   width: 90,
    //   userRole: ["admin", "sales"],
    // },
    {
      field: "customer",
      headerName: "Customer",
      width: 180,
      userRole: ["admin", "sales", "warehouse"],
    },
    {
      field: "poNumber",
      headerName: "PO Number",
      width: 240,
      userRole: ["admin", "sales", "warehouse"],
    },
    {
      field: "code",
      headerName: "Code",
      width: 150,
      userRole: ["admin", "sales", "warehouse"],
    },

    {
      field: "mfr",
      headerName: "MFR",
      width: 180,
      userRole: ["admin", "sales", "warehouse"],
    },
    {
      field: "mpn",
      headerName: "MPN",
      width: 180,
      userRole: ["admin", "sales", "warehouse"],
    },
    {
      field: "qty",
      headerName: "Qty",
      width: 150,
      userRole: ["admin", "sales", "warehouse"],
    },
    {
      field: "invoice",
      headerName: "invoice",
      width: 320,
      userRole: ["admin", "sales", "warehouse"],
    },
    {
      field: "trackingNumber",
      headerName: "Tracking Number",
      width: 150,
      userRole: ["admin", "sales", "warehouse"],
    },
    {
      field: "courier",
      headerName: "courier",
      width: 150,
      userRole: ["admin", "sales", "warehouse"],
    },
    {
      field: "coo",
      headerName: "coo",
      width: 150,
      userRole: ["admin", "sales", "warehouse"],
    },
    {
      field: "timeStamp",
      headerName: "timeStamp",
      width: 150,
      userRole: ["admin"],
    },

    // {
    //   field: "incoTerms",
    //   headerName: "IncoTerms",
    //   width: 200,
    //   userRole: ["admin", "sales"],
    //   renderCell: ({ row, ...props }) => {
    //     return (
    //       <Stack direction="row" spacing={2}>
    //         <Typography>{row?.incoTerms.terms}</Typography>
    //       </Stack>
    //     );
    //   },
    // },
  ];
  const dropdownMenu = [
    {
      label: "Download Shipping List",
      userRole: ["admin", "sales", "warehouse"],
      onClick: async ({ selectionModel }) => {
        await downloadShippingList({ items: selectionModel });
      },
    },
    {
      label: "Delete",
      userRole: ["admin"],
      onClick: async ({ client, selectionModel, setSelectionModel }) => {
        await onDeleteShipping({
          selectionModel,
          setSelectionModel,
          client,
          type: "SHIPPING",
        });
      },
    },
    {
      label: "Generate Invoices",
      userRole: ["admin"],
      onClick: async ({ client, selectionModel, setSelectionModel }) => {
        if (selectionModel.some((x) => x.invoice?.length > 0)) {
          return alert("Some of the selected items already have invoices");
        }
        Hub.dispatch("dialogMonitor", {
          event: "invoiceGen",
          data: {
            selectionModel,
            setSelectionModel,
            definerID: entityID,
            // attrs: ["price", "priceCur", "paymentTerms"],
            // model:'CPO'
          },
        });
        // await onDeletePO({
        //   selectionModel,
        //   setSelectionModel,
        //   client,
        // });
      },
    },
    {
      label: "Batch Update",
      userRole: ["admin"],
      onClick: async ({ client, selectionModel, setSelectionModel }) => {
        Hub.dispatch("dialogMonitor", {
          event: "batchUpdate",
          data: {
            selectionModel,
            setSelectionModel,
            attrs: ["number", "poID", "date", "materialID"],
            model: "ReceivingAndShipping",
          },
        });
        // await onDeletePO({
        //   selectionModel,
        //   setSelectionModel,
        //   client,
        // });
      },
    },
  ];

  const filteredColumns = getFilteredItemsByUserRole(columns, userRole);

  const filteredDropdownMenu = getFilteredItemsByUserRole(
    dropdownMenu,
    userRole
  );

  const prepareItemsFunc = (items) => {
    // console.log({ items });
    return items.map((x) => {
      return {
        ...x,
        poNumber: x.po?.no,
        customer: x.po?.customer?.abbr,
        // vendor: x.vendor?.alias || x.vendor?.name,
        code: x.materialEntityRelation?.code,
        mfr: x.material?.mfr,
        mpn: x.material?.mpn,
        invoice: x.invoice?.items?.map((x) => x.number).join(", "),
        courier: x.courier?.abbr,
      };
    });
  };

  const sortBy = (arr) => {
    arr.sort((a, b) => (a.itemNumber * 1 > b.itemNumber * 1 ? 1 : -1));
    arr.sort((a, b) => (a.number < b.number ? 1 : -1));
    arr.sort((a, b) => (a.date < b.date ? 1 : -1));

    return arr;
  };

  const filterAttrs = [
    { label: "date", value: "date", type: "date" },
    { label: "number", value: "number", type: "string" },

    {
      label: "code",
      value: "code",
      type: "string",
    },
    { label: "mfr", value: "mfr", type: "string" },
    { label: "mpn", value: "mpn", type: "string" },
    { label: "poNumber", value: "poNumber", type: "string" },

    { label: "invoice", value: "invoice", type: "string" },

    { label: "customer", value: "customer", type: "string" },
  ];

  return (
    <DataGridComp
      query={ShippingByTypeAndMaterial}
      queryVariables={queryVariables}
      sortBy={sortBy}
      onClickAddRoute={isAdmin ? "new" : null}
      columns={filteredColumns}
      DetailsDialog={isAdmin ? ItemView : null}
      userRole={userRole}
      checkboxSelection={
        ["admin", "sales", "warehouse"].some((role) => userRole?.includes(role))
      }
      getDropdownMenu={filteredDropdownMenu}
      prepareItemsFunc={prepareItemsFunc}
      ToolbarInsert={ToolbarInsert}
      filterAttrs={filterAttrs}
    />
  );
}

const shippings = {
  path: "shippings",

  sideNav: {
    group: 3,
    order: 40,
    label: "Shippings",
    entityType: ["200", "300"],
    allowedRole: ["admin", "sales", "warehouse"],
    auth: ["authenticated"],
  },
  route: {
    index: {
      element: null,
      Comp,
      allowedRole: ["admin", "sales", "warehouse"],
      entityType: "all",
      auth: ["authenticated"],
    },
    new: {
      element: <CreateShippingStepForm />,
      allowedRole: ["admin", "sales", "warehouse"],
      entityType: "all",
      auth: ["authenticated"],
    },
  },
};

function ToolbarInsert({ selectionModel }) {
  return !selectionModel?.length ? null : (
    <Stack
      direction="row"
      spacing={2}
      color="secondary.main"
      sx={{ position: "relative", top: -7 }}
    >
      <Typography variant="title" sx={{ fontWeight: 500 }}>
        SELECTED QTY:
      </Typography>
      <Typography variant="title" sx={{ fontWeight: 500 }}>
        {selectionModel.reduce((a, v) => a + (v?.qty || 0), 0).toFixed(3) * 1}
      </Typography>
    </Stack>
  );
}

export default shippings;
